const emittable = require('mithril-emittable');

function component(constructor) {
  return emittable((vnode, emit) => constructor(vnode, emit));
}

module.exports = { component };
